import httpClientUpload from './httpClientUpload'

export const uploadUserProfileImage = async (payload) => {
  const endpoint = `/refimages/createprofile`;
  return httpClientUpload.post(endpoint, payload);
}

export const uploadDeceasedProfileImage = async (payload) => {
  const endpoint = `/refimages/createprofile`;
  return httpClientUpload.post(endpoint, payload);
}

export const uploadDeceasedImages = async (payload) => {
  const endpoint = `/refimages/bulk-upload/${payload.deceasedId}`;
  return httpClientUpload.post(endpoint, payload.formData);
}

export const uploadDeceasedVideos = async (payload) => {
  const endpoint = `/refvideos/bulk-upload/${payload.deceasedId}`;
  return httpClientUpload.post(endpoint, payload.formData);
}

export const uploadDeceasedDocuments = async (payload) => {
  const endpoint = `/refdocuments/bulk-upload/${payload.deceasedId}`;
  return httpClientUpload.post(endpoint, payload.formData);
}

export const uploadDeceasedSuggestionImages = async (payload) => {
  const endpoint = `/refsuggestion/bulk-upload/${payload.deceasedId}`;
  return httpClientUpload.post(endpoint, payload.formData);
}

export const uploadDeceasedStory = async (payload) => {
  const endpoint = `/refstories/upload/${payload.deceasedId}`;
  return httpClientUpload.post(endpoint, payload.fd);
}

export default {
  uploadUserProfileImage,
  uploadDeceasedProfileImage,
  uploadDeceasedImages,
  uploadDeceasedVideos,
  uploadDeceasedDocuments,
  uploadDeceasedSuggestionImages,
  uploadDeceasedStory
}
